import { render, staticRenderFns } from "./InputTwoTextDialog.vue?vue&type=template&id=0d6e1184&scoped=true&"
import script from "./InputTwoTextDialog.vue?vue&type=script&lang=js&"
export * from "./InputTwoTextDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e1184",
  null
  
)

export default component.exports